<template>
    <div class="f-manager">
        <veui-icon name="manage-order" class="f-manager-icon"/>
        <span class="f-manager-name" @click="toggleShow">管理</span>
        <div v-if="isShowMenu"
            class="f-manager-menu">
            <div v-for="item in manager" @click="judgeOpenWindow(item.type, item.label)"
                :key="item.type" class="f-manager-menu-item">
                <veui-icon :name="item.name" class="f-manager-menu-icon"/>
                <span class="f-manager-menu-label">{{item.label}}</span>
            </div>
        </div>

        <!-- 普通确认弹窗 -->
        <ui-confirm-box :is-open="confirm"
            :title="confirmTitle"
            :tip="confirmTips"
            :btn-tip="confirmBtn"
            @operate="operate">
        </ui-confirm-box>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/components/manager-operation.less';
</style>

<script>
import {Icon} from 'veui';
import 'veui-theme-one-icons';
import ConfirmBox from '@/components/confirm-box/box';
import {throttle, debounce} from '@/utils/debounceThrottle.js';

export default {
    props: {
        topicid: {
            'type': Number,
            'default': 0
        },
        isstick: {
            'type': Number,
            'default': 0
        },
        iselite: {
            'type': Number,
            'default': 0
        },
        isbanned: {
            'type': Number,
            'default': 0
        }
    },
    components: {
        'veui-icon': Icon,
        'ui-confirm-box': ConfirmBox
    },
    data() {
        return {
            isShowMenu: false,
            confirm: false,
            confirmTips: '',
            confirmBtn: '',
            confirmTitle: '',
            confirmType: ''
        };
    },
    mounted() {
        this.globalClick(this.hideMenu);
    },
    computed: {
        manager: {
            get() {
                return [
                    {
                        name: 'arrow-to-top',
                        label: this.isstick ? '取消置顶' : '置顶',
                        type: 'top'
                    },
                    {
                        name: 'parachute',
                        label: this.iselite ? '取消加精' : '加精',
                        type: 'elite'
                    },
                    {
                        name: 'ban',
                        label: this.isbanned ? '取消禁言' : '禁言',
                        type: 'ban'
                    },
                    {
                        name: 'trash-alt',
                        label: '删除',
                        type: 'delete'
                    }
                ];
            }
        }
    },
    methods: {
        hideMenu(target) {
            if (!(typeof target.className === 'string' && target.className.indexOf('f-manager-name') > -1)) {
                this.isShowMenu = false;
            }
        },
        toggleShow() {
            this.isShowMenu = !this.isShowMenu;
        },
        judgeOpenWindow(type, label) {
            if (type === 'delete') {
                this.confirm = true;
                this.confirmType = type;
                this.confirmTitle = '确认删除帖子';
                this.confirmTips = '删除后帖子内容及回复将一并被删除，且不可恢复';
                this.confirmBtn = '删除';
                return;
            }
            this.managerOperation(type);
        },
        ok: debounce(function () {
            this.managerOperation(this.confirmType);
        }),
        managerOperation: throttle(function (type) {
            let topicId = this.topicid;
            let enable = 1;
            switch (type) {
                case 'top': enable = this.isstick ? 0 : 1;
                    break;
                case 'elite': enable = this.iselite ? 0 : 1;
                    break;
                case 'ban': enable = this.isbanned ? 0 : 1;
                    break;
            }
            this.$store.dispatch('managerOperation', {type, topicId, enable})
                .then(() => {
                    this.isShowMenu = false;
                    this.$emit('refreshlist', type);
                    // 后续可以通过用户id判断是否自己再添加
                    // if (type === 'ban' && this.isauthor) {
                    if (type === 'ban') {
                        this.$store.dispatch('getUserInfo');
                    }
                });
        }),
        changeConfirm(val) {
            this.confirm = val;
        },
        operate(type) {
            if (type === 'ok') {
                this.ok();
            }
            this.changeConfirm(false);
        }
    }
};
</script>
